import { ILocationOption } from "@types-custom/models/business/location.model";

export interface IAlertModel {
  "id": number,
  "layer": string,
  "title": string,
  "date": string,
  "location": string,
  "value": string
}

export interface IAlertHistoryModel {
  id: number;
  alertConfigName: string;
  value: string;
  measurementUnit: string;
  name: string;
  publicationDate: string;
  moduleCode: string;
  isRead: boolean;
}

export interface IAlert {
  id: number,
  moduleId: number,
  moduleName: string,
  name: string,
  priorityId: number,
  priorityName: string,
  stateId: number,
  stateName: string,
  state?: boolean,
}

export interface IAlertEditModel {
  id: number;
  moduleId: number;
  moduleName: string;
  name: string;
  description: string;
  priorityId: number;
  priorityName: string;
  variableId: number;
  variableName: string;
  deviceConditionId: number;
  deviceConditionName: string;
  measurementUnit: string;
  stateId: number;
  stateName: string;
  sensorTypeId: number;
  indicatorId: number;
  thresholds: IThresholdsModel[];
}

export interface IThresholdsModel {
  id: number;
  index?: number;
  rangeName: string;
  operatorId: number;
  operatorName: string;
  initialValue: number;
  finalValue: number;
  stationIds: number[];
}

export const alertTypeList = [
  {
    label: 'Tráfico',
    value: 'trafico',
  } as ILocationOption,
  {
    label: 'Zonas de parking',
    value: 'false',
  } as ILocationOption,
  {
    label: 'Calidad del aire y ruido',
    value: 'false',
  } as ILocationOption,
];

export enum AlertFormEmun {
  MODULE = 'moduleId',
  NAME = 'name',
  PRIORITY = 'priorityId',
  VARIABLE = 'variableId',
  CONDITION = 'deviceConditionId',
  MEASUREMENT_UNIT = 'measurementUnit',
  TYPE = 'sensorTypeId',
  INDICATOR = 'indicatorId',
  STATE = 'stateId',
  THRESHOLDS = 'thresholds',
}

export enum AlertFormListEnum {
  MODULE_LIST = 'Modulo',
  PRIORITY_LIST = 'Prioridad',
  VARIABLE_LIST = 'Variable',
  DEVICE_STATE_LIST = 'Estado',
  AIR_INDICATORS = 'Indicador',
  SENSOR_TYPE = 'TipoSensor',
  SENSOR_STATE = 'CondicionDispositivo',
  OPERATORS = 'Operador',
  MEASUREMENT_LIST = 'Measurement',
}
